var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvlTokenBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 7,
    fill: "#D2FFE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0002 21.91C27.0202 22.66 26.8202 23.37 26.4602 23.98C26.2602 24.34 25.9902 24.6701 25.6902 24.9401C25.0002 25.5801 24.0902 25.9701 23.0802 26.0001C21.6202 26.0301 20.3302 25.2801 19.6202 24.1301C19.2402 23.5401 19.0102 22.8301 19.0002 22.0801C18.9702 20.8201 19.5302 19.6801 20.4302 18.9301C21.1102 18.3701 21.9702 18.0201 22.9102 18.0001C25.1202 17.9501 26.9502 19.7 27.0002 21.91Z",
    stroke: "#01BA3A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4404 22.03L22.4504 22.99L24.5404 20.97",
    stroke: "#01BA3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16992 11.4399L15.9999 16.5499L24.7699 11.4699",
    stroke: "#01BA3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.61V16.54",
    stroke: "#01BA3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6101 13.17V18.83C25.6101 18.88 25.6101 18.92 25.6001 18.97C24.9001 18.36 24.0001 18 23.0001 18C22.0601 18 21.1901 18.33 20.5001 18.88C19.5801 19.61 19.0001 20.74 19.0001 22C19.0001 22.75 19.2101 23.46 19.5801 24.06C19.6701 24.22 19.7801 24.37 19.9001 24.51L18.0701 25.52C16.9301 26.16 15.0701 26.16 13.9301 25.52L8.59012 22.56C7.38012 21.89 6.39014 20.21 6.39014 18.83V13.17C6.39014 11.79 7.38012 10.11 8.59012 9.44002L13.9301 6.48C15.0701 5.84 16.9301 5.84 18.0701 6.48L23.4101 9.44002C24.6201 10.11 25.6101 11.79 25.6101 13.17Z",
    stroke: "#01BA3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvlTokenBg);
export default __webpack_public_path__ + "static/media/avl-token-bg.e24a5b356315a8469df60ddbe59e661d.svg";
export { ForwardRef as ReactComponent };